import React, { Component } from "react";
import "./deliveryMethod.css";
import { Button } from "react-bootstrap";
import Validation from "../../../Shared/Validation";
import SecurityVerificationPopUp from "./securityVerificationPopUp";
import Modal from "react-modal";
import { NotificationManager } from "react-notifications";
import InputMask from "react-input-mask";
import AppHelper from "../../../helpers/appHelper";
import { isMobile } from "../../../helpers/utils";
import "./mobileStyle.css";

class TextMessageComponent extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      showVerificationnModal: false,
      showVerificationnModalForAdd: false,
      verifyModel: false,
      opacity: 1,
      showaddcomponent: false,
      showaddlink: false,
      phoneNumber: "",
      EditedPhoneNumber: ""
    };
  }

  validatePhoneNumber(number) {
    const pattern = /[0-1]{1}[-\s.]?[0-9]{3}[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/im;
    const result = pattern.test(number);
    return result;
  }

  makeappear = () => {
    this.setState(prevState => ({ opacity: prevState.opacity - 0 }));
    this.setState({ showaddcomponent: true });
  };

  makedisappear = () => {
    this.setState({ showaddlink: false });
  };

  startEditing = () => {
    this.setState(prevState => ({
      opacity: prevState.opacity - 0
    }));
    this.setState({ isEditing: true });
  };

  handleDelete = () => {
    alert("Button Clicked!");
  };
  renderVerification = () => {
    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "65%",
        minWidth: "65%"
      }
    };
    return (
      <Modal
        style={customStyles}
        ariaHideApp={false}
        isOpen={this.state.showVerificationnModal}
        onRequestClose={() => {
          this.setState({ showVerificationnModal: false, currentItem: {} });
        }}
        contentLabel="Phone Verification Modal"
      >
        <SecurityVerificationPopUp
          onCancel={() => {
            this.setState({ showVerificationnModal: false, currentItem: {} });
            this.props.updateBankingAlertValues({
              currentEditItemId: "",
              currentEditItemType: "",
              currentEditItemValue: ""
            });
          }}
          resendCode={() => {
            const phoneNumber = this.props.deliveryEditItem.currentEditItemValue.split(
              "-"
            );

            this.props.triggerVerificationCode(
              {
                phoneNumber: phoneNumber[2] + phoneNumber[3],
                areaCode: phoneNumber[1],
                countryCode: phoneNumber[0],
                id:
                  this.state.currentItem.id ||
                  this.props.deliveryEditItem.currentEditItemId
              },
              "PhoneNumber"
            );
          }}
          onSubmit={code => {
            const phoneNumber = this.props.deliveryEditItem.currentEditItemValue.split(
              "-"
            );
            this.props
              .submitVerificationCode(
                {
                  phoneNumber: phoneNumber[2] + phoneNumber[3],
                  areaCode: phoneNumber[1],
                  countryCode: phoneNumber[0],
                  address: this.props.deliveryEditItem.currentEditItemValue,
                  verificationCode: code,
                  id:
                    this.state.currentItem.id ||
                    this.props.deliveryEditItem.currentEditItemId,
                  verifiedBy: "NotificationCenter"
                },
                "PhoneNumber"
              )
              .then(res => {
                if (res) {

                  var alertTextId = document.getElementById('showTextAlert');
                  var alertEmailId = document.getElementById('showEmailAlert');
                  alertEmailId.style.display = 'none';
                  alertTextId.style.display = 'block';
                  alertTextId.innerHTML = 'Verified successfully';
                  alertTextId.classList.add("alignAlert");

                  this.props.updateBankingAlertValues({
                    currentEditItemId: "",
                    currentEditItemType: "",
                    currentEditItemValue: ""
                  });
                  this.setState({
                    showVerificationnModal: false,
                    currentItem: {}
                  });
                  this.props.addBankingAlertValue({
                    currentAddItemType: "",
                    currentAddItemValue: ""
                  });
                }
              });
          }}
        ></SecurityVerificationPopUp>
      </Modal>
    );
  };
  render() {
    const {
      deliveryEditItem: { currentEditItemType },
      deliveryAddItem: { currentAddItemType },
      addBankingAlertValue,
      history
    } = this.props;
    const EditedPhoneNumber = this.state.EditedPhoneNumber.split("-");
    const disabled =
      currentEditItemType !== "Phone" && currentEditItemType !== "";
    const addDisabled =
      currentAddItemType !== "Phone" && currentAddItemType !== "";
    let newPhone;

    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "45%",
        minWidth: "45%"
      }
    };


    var smsAddresses = this.props.items.filter(element => element.channel === 'SMS');
    var buttonText = "Add Phone Number";

    if (smsAddresses.length > 9)  buttonText = "Maximum number of phone numbers has been reached. Please remove a phone number before another can be added.";
    const maxSMSAdded = (smsAddresses.length > 9);



    if (currentAddItemType === "" || currentAddItemType !== "Phone") {
      newPhone = isMobile() && !maxSMSAdded ? (
        <a
          className="AppLink inputField textField"
          id="addPhone"
          tabIndex={0}
          href={`#/emailOrPhoneEdit/phone`}
        >
          Add Phone Number
        </a>
      ) : (
        <Button
          variant="Link"
          className="AppLink desktop align-content-items-for-delivery-method-mobile"
          id="addPhone"
          tabIndex={0}
          onClick={() => {
            this.props.updateBankingAlertValues({
              currentEditItemId: "",
              currentEditItemType: "",
              currentEditItemValue: "",
              isValid: false
            });
            this.props.addBankingAlertValue({
              currentAddItemType: "Phone",
              currentAddItemValue: "1",
              isValid: false
            });
          }}
          disabled={disabled || addDisabled || currentEditItemType === "Phone" || maxSMSAdded}
        >
          {buttonText}
        </Button>
      );
    }

    return (
      <div
        id="dvTextMessagingsection"
        className={
          `comp-category-container-addEdit ` +
          (disabled || addDisabled ? `disabled-dm` : ``)
        }
      >
        <h3
          id="textMsg"
          className={
            isMobile()
              ? `mobile-font-family mobile-category`
              : `text-message-header`
          }
        >
          {this.props.name}
        </h3>
        <div className="hr-addEdit-deliveryMethod" />

        {/* Alert for Low vision users */}
        <div id="showTextAlert" >
        </div> 

        {this.props.items.map((item, key) => {
          const itemDisabled =
            this.props.deliveryEditItem.currentEditItemType === "Phone" &&
            this.props.deliveryEditItem.currentEditItemId !== item.id;
          const addItemDisabled =
            this.props.deliveryAddItem.currentAddItemType === "Phone";
          const Edit =
            isMobile() &&
            this.props.deliveryEditItem.currentEditItemId === "" ? (
              <Button
                disabled={
                  disabled || addDisabled || itemDisabled || addItemDisabled
                }
                aria-label={
                  `Edit ` +
                  item.countryCode +
                  item.areaCode +
                  item.phoneNumber +
                  ` phone number`
                }
                variant="Link"
                className={
                  isMobile()
                    ? `mobile-font-family AppLink mobile-edit-item padding-unset padding-left`
                    : `AppLink mobile`
                }
                href={`#/emailOrPhoneEdit/${item.id}/phone`}
              >
                Edit
              </Button>
            ) : (
              <Button
                variant="Link"
                disabled={
                  disabled || addDisabled || itemDisabled || addItemDisabled
                }
                aria-label={
                  `Edit ` +
                  item.countryCode +
                  item.areaCode +
                  item.phoneNumber +
                  ` phone number`
                }
                tabIndex={0}
                id={"EditTextItem" + key}
                className="AppLink edit-item padding-unset padding-left"
                onClick={() => {
                  this.props.updateBankingAlertValues({
                    currentEditItemId: item.id,
                    currentEditItemType: "Phone",
                    currentEditItemValue:
                      item.countryCode +
                      "-" +
                      item.areaCode +
                      "-" +
                      item.phoneNumber,
                    isValid: this.validatePhoneNumber(
                      item.countryCode +
                        "-" +
                        item.areaCode +
                        "-" +
                        item.phoneNumber
                    )
                  });

                  setTimeout(() => {
                    if (this.textInput.current) {
                      this.textInput.current.focus();
                    }
                  }, 1000);

                  this.setState({
                    EditedPhoneNumber:
                      item.countryCode +
                      "-" +
                      item.areaCode +
                      "-" +
                      item.phoneNumber.substring(0, 3) +
                      "-" +
                      item.phoneNumber.substring(3, 7),
                    currentItem: item
                  });
                }}
              >
                Edit
              </Button>
            );
          return (
            <div
              key={key}
              className={
                (itemDisabled ? "disabled-dm" : "") +
                (addItemDisabled ? "disabled-dm" : "") +
                ` textMessage-align-content`
              }
            >
              {this.props.deliveryEditItem.currentEditItemId !== item.id ||
              this.state.isEditing ? (
                <div className="displayFlex">
                  <div className="flex1">
                    <label
                      id={"TextItem" + key}
                      className={
                        isMobile()
                          ? `mobile-font-family mobile-align-content-items-for-delivery-method`
                          : `align-content-items-for-delivery-method`
                      }
                    >
                      {AppHelper.formatPhoneNumber(
                        item.countryCode + item.areaCode + item.phoneNumber
                      )}
                    </label>
                    {!item.isVerified && (
                      <Validation
                        message={`Number not verified`}
                        messageId={`NumberVerifyText` + key}
                        className="align-validation-message"
                      />
                    )}
                  </div>
                  <div className="padding-top-button">
                    {!item.isVerified && (
                      <Button
                        variant="Link"
                        aria-label={
                          `Verify ` +
                          item.countryCode +
                          item.areaCode +
                          item.phoneNumber +
                          ` phone number`
                        }
                        id={"VerifyItem" + key}
                        tabIndex={0}
                        className={
                          isMobile()
                            ? `mobile-font-family AppLink dividerColor mobile-edit-item padding-unset padding-right`
                            : `AppLink dividerColor edit-item padding-unset padding-right`
                        }
                        onClick={() => {
                          this.props
                            .triggerVerificationCode(
                              {
                                countryCode: item.countryCode,
                                areaCode: item.areaCode,
                                phoneNumber: item.phoneNumber,
                                id: item.id
                              },
                              "DeliveryMethods"
                            )
                            .then(res => {
                              this.setState({
                                showVerificationnModal: true,
                                currentItem: item
                              });
                              if (res) {
                                //res is coming as empty hence it should be ouside if

                                if (isMobile()) {
                                  this.props.addCurrentOperatingValue(
                                    item.countryCode +
                                      "-" +
                                      item.areaCode +
                                      "-" +
                                      item.phoneNumber
                                  );
                                  history.push(
                                    `/verifyEmailOrPhone/phone/` + item.id
                                  );
                                } else {
                                  this.setState({
                                    showVerificationnModal: true,
                                    currentItem: item
                                  });
                                }
                              }
                            });
                        }}
                        disabled={
                          disabled ||
                          addDisabled ||
                          itemDisabled ||
                          addItemDisabled
                        }
                      >
                        Verify
                      </Button>
                    )}
                  </div>
                  <div className="padding-top-button">
                    {Edit}
                    <span className="sr-only">
                      {`Edit ` +
                        item.countryCode +
                        item.areaCode +
                        item.phoneNumber +
                        ` phone number`}
                    </span>
                  </div>
                </div>
              ) : (
                <div
                  className="comp-category-container-addEdit displayFlex justify-content spacing padding-top"
                  key={key}
                >
                  <div>
                    <InputMask
                      mask="9-999-999-9999"
                      placeholder="Phone number"
                      type="text"
                      id={"PhoneEditInputItem" + key}
                      value={this.props.deliveryEditItem.currentEditItemValue}
                      onChange={event => {
                        this.props.updateBankingAlertValues({
                          currentEditItemValue: event.target.value,
                          isValid: this.validatePhoneNumber(event.target.value)
                        });
                        this.setState({
                          EditedPhoneNumber: event.target.value
                        });
                      }}
                      ref={this.textInput}
                      className={`bg-light text-dark form-control ${
                        this.props.deliveryEditItem.isValid
                          ? "is-valid"
                          : "is-invalid"
                      }`}
                    />

                    {!this.props.deliveryEditItem.currentEditItemValue
                      .isValid && (
                      <div className="invalid-feedback">
                        Invalid phone number
                      </div>
                    )}
                  </div>
                  <div className="alignbuttons">
                    <Button
                      id={"SaveItem" + key}
                      className="alignColor left-margin"
                      //disabled={!this.props.deliveryEditItem.isValid || item.address === this.props.deliveryEditItem.currentEditItemValue}
                      //  disabled={!this.props.deliveryEditItem.isValid || (item.countryCode === EditedPhoneNumber[0] && item.areaCode === EditedPhoneNumber[1] && item.phoneNumber === EditedPhoneNumber[2] + EditedPhoneNumber[3])}
                      onClick={() => {
                        if (!this.props.deliveryEditItem.isValid) {
                          NotificationManager.error(
                            "Invalid Phone number.Try again"
                          );
                          return;
                        } else if (
                          item.countryCode === EditedPhoneNumber[0] &&
                          item.areaCode === EditedPhoneNumber[1] &&
                          item.phoneNumber ===
                            EditedPhoneNumber[2] + EditedPhoneNumber[3]
                        ) {
                          NotificationManager.error(
                            " Phone number is not changed.Try again "
                          );
                          return;
                        }
                        this.props
                          .saveAndVerifyDeliveryMethod({
                            id: item.id,
                            countryCode: EditedPhoneNumber[0],
                            areaCode: EditedPhoneNumber[1],
                            phoneNumber:
                              EditedPhoneNumber[2] + EditedPhoneNumber[3],
                            deliveryChannel: "SMS",
                            isTextBankingEnabled: item.isTextBankingEnabled
                          })
                          .then(response => {
                            if (response) {

                              var alertTextId = document.getElementById('showTextAlert');
                              var alertEmailId = document.getElementById('showEmailAlert');
                              alertEmailId.style.display = 'none';
                              alertTextId.style.display = 'block';
                              alertTextId.innerHTML = 'Updated successfully';
                              alertTextId.classList.add("alignAlert");

                              this.setState({
                                showVerificationnModal: true,
                                showaddcomponent: false
                              });
                            }
                          });
                      }}
                    >
                      {this.props.buttontext}
                    </Button>

                    <Button
                      aria-label={
                        `cancel editing ` +
                        item.countryCode +
                        item.areaCode +
                        item.phoneNumber +
                        ` phone number`
                      }
                      id={"CancelItem" + key}
                      className="aligncancelbuttoncolor left-margin"
                      onClick={() => {
                        this.props.updateBankingAlertValues({
                          currentEditItemId: "",
                          currentEditItemType: "",
                          currentEditItemValue: ""
                        });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      aria-label={
                        `Delete ` +
                        item.countryCode +
                        item.areaCode +
                        item.phoneNumber +
                        ` phone number`
                      }
                      id={"DeleteItem" + key}
                      variant="Link"
                      className="AppLink"
                      onClick={() => {
                        this.props.showDeleteConfirmation(
                          "Are you sure you want to delete " +
                            item.countryCode +
                            "-" +
                            item.areaCode +
                            "-" +
                            item.phoneNumber,
                          () => {

                            var alertTextId = document.getElementById('showTextAlert');
                            var alertEmailId = document.getElementById('showEmailAlert');
                            alertEmailId.style.display = 'none';
                            alertTextId.style.display = 'block';
                            alertTextId.innerHTML = 'Phone number deleted successfully';
                            alertTextId.classList.add("alignAlert");

                            this.props.deletePhoneNumber({
                              id: item.id
                            });
                          }
                        );
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        <Modal
          style={customStyles}
          isOpen={this.state.verifyModel}
          onRequestClose={() => {
            this.setState({ verifyModel: false, currentItem: {} });
          }}
          contentLabel="Example Modal"
        >
          <SecurityVerificationPopUp
            onCancel={() => {
              this.setState({ verifyModel: false, currentItem: {} });
            }}
            resendCode={() => {
              const item = this.state.currentItem;
              this.props.triggerVerificationCode(
                {
                  countryCode: item.countryCode,
                  areaCode: item.areaCode,
                  phoneNumber: item.phoneNumber,
                  id: item.id
                },
                "DeliveryMethods"
              );
            }}
            onSubmit={code => {
              const item = this.state.currentItem;
              this.props.submitVerificationCode(
                {
                  verificationCode: code,
                  id: item.id
                },
                "DeliveryMethods"
              );
              this.setState({ verifyModel: false, currentItem: {} });
            }}
          ></SecurityVerificationPopUp>
        </Modal>
        <div
          className={
            this.props.deliveryEditItem.currentEditItemType === "Phone"
              ? "disabled-dm"
              : ""
          }
        >
          <div
            className={
              isMobile()
                ? `mobile-font-family add-new-item-mobile`
                : `add-new-item`
            }
          >
            {this.props.items.length === 0 && (
              <div
                className={
                  isMobile()
                    ? `padding-top italic`
                    : `spacing padding-top italic`
                }
              >
                No Phone Numbers found
              </div>
            )}
            {newPhone}
          </div>
          {this.props.deliveryAddItem.currentAddItemType === "Phone" && (
            <div className="containerForAddingPhoneNumber">
              <div className="hr-add-edit-deliveryMethod" />
              <div className="comp-category-container-addEdit displayFlex justify-content spacing">
                <div>
                  <InputMask
                    mask="9-999-999-9999"
                    placeholder="Phone number"
                    type="text"
                    id="phoneNumberTextBox"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className={`bg-light text-dark form-control ${
                      this.props.deliveryAddItem.isValid
                        ? "is-valid"
                        : "is-invalid"
                    }`}
                    onChange={event => {
                      addBankingAlertValue({
                        currentAddItemValue: event.target.value,
                        isValid: this.validatePhoneNumber(event.target.value)
                      });
                    }}
                    value={this.props.deliveryAddItem.currentAddItemValue}
                  />

                  {!this.props.deliveryAddItem.isValid && (
                    <div className="invalid-feedback">Invalid phone number</div>
                  )}
                </div>
                <div className="flex1">
                  <Validation
                    className="align-validation-message"
                    message={`Number not verified`}
                    messageId={`NumberVerifyTextForAdd`}
                  />
                </div>
                <div className="alignbuttons">
                  <Button
                    className="alignColor "
                    //    disabled={!this.props.deliveryAddItem.isValid}
                    onClick={() => {
                      if (!this.props.deliveryAddItem.isValid) {
                        NotificationManager.error(
                          "Invalid Phone number.Try again"
                        );
                        return;
                      } else {
                        const phoneNumber = this.props.deliveryAddItem.currentAddItemValue.split(
                          "-"
                        );
                        this.props
                          .addPhoneNumber({
                            countryCode: phoneNumber[0],
                            areaCode: phoneNumber[1],
                            phoneNumber: phoneNumber[2] + phoneNumber[3],
                            deliveryChannel: "SMS",
                            isTextBankingEnabled: "false"
                          })
                          .then(response => {
                            if (response) {
                              var alertEmailId = document.getElementById('showEmailAlert');
                              var alertTextId = document.getElementById('showTextAlert');
                              alertEmailId.style.display = 'none';
                              alertTextId.style.display = 'block';
                              alertTextId.innerHTML = 'Phone number created successfully';
                              alertTextId.classList.add("alignAlert");

                              this.setState({
                                showVerificationnModal: true,
                                showaddcomponent: false,
                                currentItem: response
                              });

                              this.props.addBankingAlertValue({
                                currentAddItemType: "",
                                currentAddItemValue: ""
                              });
                            }
                          });
                      }
                    }}
                  >
                    {this.props.buttontext}
                  </Button>
                  <Button
                    aria-label={`cancel add phone number`}
                    className="aligncancelbuttoncolor left-margin"
                    onClick={() => {
                      this.setState({ showaddcomponent: false });
                      this.props.addBankingAlertValue({
                        currentAddItemType: "",
                        currentAddItemValue: ""
                      });
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
              <div className="hr-add-edit-deliveryMethod" />
            </div>
          )}
        </div>
        {this.renderVerification()}
        <div className="hr-addEdit-deliveryMethod" />
      </div>
    );
  }
}
export default TextMessageComponent;
